const messages = {
    accountBox: {
        title: "Översikt",
        description: "Följ snabbt dina kampanjer och poäng.",
        button: "ÖPPNA ÖVERSIKT",
    },
};

export default {
    messages,
};
